/* Honor U Design B navigation (2026-10-08). Mega panel + mobile drawer. No dependencies. */
(function () {
  var CLOSE_DELAY = 400;
  function initMega(item) {
    if (item.dataset.huReady) return; item.dataset.huReady = '1';
    var trigger = item.querySelector('[data-hu-mega-trigger]');
    var panel = item.querySelector('[data-hu-mega-panel]');
    if (!trigger || !panel) return;
    var timer = null, lastPointer = 'mouse', openAtDown = false;
    function open() { clearTimeout(timer); item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    function close() { clearTimeout(timer); item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
    function closeLater() { clearTimeout(timer); timer = setTimeout(close, CLOSE_DELAY); }
    item.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') open(); });
    item.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') closeLater(); });
    trigger.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType; openAtDown = item.classList.contains('is-open'); });
    trigger.addEventListener('click', function (e) {
      // Touch / pen: first tap opens the panel, second tap follows the link.
      if (lastPointer !== 'mouse' && !openAtDown) { e.preventDefault(); open(); }
      lastPointer = 'mouse'; openAtDown = true;
    });
    trigger.addEventListener('keydown', function (e) {
      if ((e.key === 'ArrowDown' || e.key === ' ') && !item.classList.contains('is-open')) {
        e.preventDefault(); open(); var first = panel.querySelector('a'); if (first) first.focus();
      }
    });
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) closeLater(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) { var had = item.contains(document.activeElement); close(); if (had) trigger.focus(); }
    });
    document.addEventListener('click', function (e) { if (!item.contains(e.target)) close(); });
  }
  function initDrawer(d) {
    if (d.dataset.huReady) return; d.dataset.huReady = '1';
    d.addEventListener('toggle', function () { document.documentElement.classList.toggle('hu-drawer-open', d.open); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) { d.open = false; d.querySelector('summary').focus(); } });
    document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) d.open = false; });
  }
  function init(root) {
    (root || document).querySelectorAll('[data-hu-mega]').forEach(initMega);
    (root || document).querySelectorAll('[data-hu-drawer]').forEach(initDrawer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
